import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shown on assessment/results pages when the teacher has no current-school-year
 * classes or students yet (v3.29.0) — instead of blank dropdowns/tables.
 */
function NoRosterNotice({ pageLabel = 'this page' }) {
  return (
    <div style={{ maxWidth: '640px', margin: '40px auto', padding: '24px 28px', background: '#eff6ff', border: '1px solid #3b82f6', borderRadius: '12px', textAlign: 'center' }}>
      <div style={{ fontSize: '2em', marginBottom: '8px' }}>🧑‍🏫</div>
      <h3 style={{ margin: '0 0 10px', color: '#1e3a8a' }}>Add a class and students first</h3>
      <p style={{ margin: '0 0 14px', color: '#1e40af', lineHeight: 1.6 }}>
        You don't have any classes or students for this school year yet, so {pageLabel} has
        nothing to show. Add your class and students (or import a roster CSV), then come back.
      </p>
      <Link
        to="/student-management"
        style={{ display: 'inline-block', padding: '10px 22px', background: '#3b82f6', color: 'white', borderRadius: '8px', textDecoration: 'none', fontWeight: 'bold' }}
      >
        Go to Classes &amp; Students
      </Link>
    </div>
  );
}

export default NoRosterNotice;
